import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlertController, NavController, NavParams, PopoverController } from 'ionic-angular';
import { CuentasPorCobrarProvider } from '../../providers/cuentas-por-cobrar/cuentas-por-cobrar';
import { CajaProvider } from '../../providers/caja/caja';
import { Storage } from '@ionic/storage'
import { DianProvider } from '../../providers/dian/dian';
import { UtilsProvider } from '../../providers/utils/utils';
import { CompaniasProvider } from '../../providers/companias/companias';
import { PushProvider } from '../../providers/push/push';
import { AuthService } from '../../providers/auth-service';
import { EntidadesProvider } from '../../providers/entidades/entidades';
import { ClientesProvider } from '../../providers/clientes/clientes';
import { InformesProvider } from '../../providers/informes/informes';
import { DEETDMRCSP_POS_NIT, DEETDMRCSP_POS_NOMBRE_APELLIDO, DEETDMRCSP_POS_NOMBRE_SOFTWARE, DEETDMRCSP_POS_RAZON_SOCIAL, MODO_DESCONECTADO, NUBE_AWS } from '../../config/url.servicio';
import { UUID } from 'angular2-uuid';
import { poselectronico } from '../../models/posElectronico';
import { factura } from '../../models/factura/factura';
import { ImprimirGlobalComponent } from '../../pages/imprimir-global/imprimir-global';

@Component({
  selector: 'pos-electronico',
  templateUrl: 'pos-electronico.html',
  providers: [  DianProvider, CompaniasProvider,EntidadesProvider,
    AuthService ]
})
export class PosElectronicoComponent implements OnInit {
  @Input() arrayWhereLocal: any = []
  public clientesId:any
  recibo:string = "";
  pagoTotal:boolean=false
  datosCredito = []
  clienteId = []
  valoresTotales = []
  valorPagado:number = 0
  valorPendiente:number = 0
  data: any[][]

  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  ventasDiarias = []
  ventasDiariasAll = []
  ventasDiariasFacturaElectronica = []
  ImpuestosLinea = []
  impuestosFactura = []
  fechaDesde:Date | string
  fechaHasta:Date | string
  visualizaDetalleReciboEnCaja: boolean = false
  resolucionDian: string = ""
  prefijoDian: string = ""
  facturaPOSDIAN: string = ""
  manejaFacturaElectronica: boolean= false
  setPruebasFacturaElectronica: boolean = false
  suscriptorDian: string = ""
  companiasId:string = ""

  DetalleFactura = []
  numeroFacturaElectronica: string = ''
  nombreIntegrado:string = ''
  identificacion:number =  0
  isLoading: boolean = false;
  segId: string = 'crearfacturaelectronica'
  buscarFechaDesde:Date | string
  buscarFechaHasta:Date | string
  buscarLasFacturasGeneradas = []
  descripcionFactura: string = ""
  @Input() facturapos: any;
  @Input() facturaeliminar: any;
  @Output() valueChange = new EventEmitter<any>();
  @Output() loaderDian = new EventEmitter<any>();
   ip:string = ''
   cufe:string = ''
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public buscarCuentasPorCobrarProvider:CuentasPorCobrarProvider,
    public servicio:CajaProvider,
    private storage: Storage,
    public alertControllers: AlertController,
    public dian: DianProvider,
    public utils:UtilsProvider,
    public servicioCompania:CompaniasProvider,
    public push:PushProvider,
    public auth: AuthService,
    public servicioEntidades: EntidadesProvider,
    public servicioCliente:ClientesProvider,
    public servicioExcel:InformesProvider,
    private popoverCtrl: PopoverController,) {     }

    async ionViewDidLoad() {
      await this.cargarVariablesDeSesion()
    }

  async generarPoselectronico() {
    let data = await this.buscarVentasdiariasCajaDeetdmrcs(this.facturapos)
    this.generarFacturaElectronica(data);
  }

  buscarVentasdiariasCajaDeetdmrcs(factura: any): Promise<any>{
  return new Promise((resolve, reject) => {
    this.storage.get('companiasId').then((companiasId) => {
      this.dian.buscarVentasPosElectronicodeetdmrcs(companiasId, factura)
        .subscribe((data) => {
          let response = null;
          if (NUBE_AWS) {
            this.ventasDiarias = JSON.parse(data['_body']).data[0] === undefined ? [] : JSON.parse(data['_body']).data;
            this.ventasDiariasAll = JSON.parse(data['_body']).data[0] === undefined ? [] : JSON.parse(data['_body']).data[1];
            response = { ventasDiarias: this.ventasDiarias, ventasDiariasAll: this.ventasDiariasAll };
          } else {
            this.ventasDiarias = JSON.parse(data['_body']);
            response = { ventasDiarias: this.ventasDiarias };
          }
          resolve(response);
        }, (error) => {
          reject(error);
        });
    });
  });
  }
  async presentAlertConfirm() {
    const alert = await this.alertControllers.create({
      title: '# Pos electrónico',
        inputs: [
          {
            name: 'numerofacturaelectronica',
            placeholder: 'Número pos electrónico'
          }
        ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (data) => {
            this.numeroFacturaElectronica = data
            console.log('Confirm Cancel: data', data);
          }
        }, {
          text: 'Okay',
          handler: () => {
            console.log('Confirm Okay');
          }
        }
      ]
    });
    await alert.present();
  }
  async generarFacturaElectronica(data: any, queHago: boolean = true,descripcionFactura: string = "") {
    // queHago = true = genera factura electrónica queHago = false = reversa el pos electrónica
    await this.cargarVariablesDeSesion();
    let mensaje = queHago ? '¿Está Seguro de Generar este Documento equivalente electrónico tiquete de máquina registradora con sistema P.O.S?' : '¿Está Seguro de eliminar este pos electrónico?'
    this.utils.mensajeConfirmacionDos('Documento equivalente electrónico tiquete de máquina registradora con sistema P.O.S',mensaje,'question','Si','No')
    .then(async (cancelarFacturaElectronica: boolean) => {
      if (cancelarFacturaElectronica) {
        if(!this.manejaFacturaElectronica) {
          this.utils.mensajeMuestro('No tiene el módulo de Documento equivalente electrónico tiquete de máquina registradora con sistema P.O.S activo verifique','Advertencia!','error')
          this.isLoading = false
          this.loaderDian.emit(0)
          return
        }
        this.limpiarFactura()
        if(this.facturaeliminar) {
          queHago = false
          this.nombreIntegrado = 'Consumidor final'
          this.identificacion =  222222222
        } else {
          this.nombreIntegrado = queHago ? data.ventasDiarias[0][0].cliente : 'Consumidor final'
          this.identificacion =  queHago ? data.ventasDiarias[0][0].identificacion : 222222222
        }

        if(!queHago){
          let responseCompania = await this.dian.devolverCompania()
          let companiaId = this.companiasId == undefined ? responseCompania : this.companiasId

          if(companiaId == undefined) {
            this.utils.mensajeMuestro('Debe salir y volver a entrar a la aplicación para generar la nota crédito..','Advertencia!','advertencia')
            this.isLoading = false
            this.loaderDian.emit(0)
            return
          }
          let ventasDiariasFacturaElectronica: any = await this.dian.buscarVentasFacturaElectronicaGeneradasPOS(companiaId, this.facturapos)
          let responseJsonventasDiariasFacturaElectronica = JSON.parse(ventasDiariasFacturaElectronica['_body'])
          let responseVentasDiariasFacturaElectronica = responseJsonventasDiariasFacturaElectronica.data[0]
          if(responseVentasDiariasFacturaElectronica.length === 0){
              this.utils.mensajeMuestro('El documento al que desea hacer una nota crédito no existe verifique..','Advertencia!','advertencia')
              this.isLoading = false
              this.loaderDian.emit(0)
              return
            } else {
              let ventasDiariasFacturaElectronicaBody  = ventasDiariasFacturaElectronica['_body']
              let ventasDiariasFacturaElectronicaJson = JSON.parse(ventasDiariasFacturaElectronicaBody)
              console.log('ventasDiariasFacturaElectronicaJson', ventasDiariasFacturaElectronicaJson.data)
              if(ventasDiariasFacturaElectronicaJson.data[0].length === 0) {
                this.utils.mensajeMuestro('El documento al que desea hacer una nota crédito no fue encontrado verifique..','Advertencia!','advertencia')
                this.isLoading = false
                this.loaderDian.emit(0)
                return
              }else {
                this.ventasDiariasFacturaElectronica = ventasDiariasFacturaElectronicaJson.data[0]
                this.numeroFacturaElectronica = this.ventasDiariasFacturaElectronica[0].factura
                this.facturaPOSDIAN = this.ventasDiariasFacturaElectronica[0].facturaPOS
                this.ventasDiariasFacturaElectronica = this.ventasDiariasAll.filter((item) => item.factura == this.facturapos )
              }

            }
        }else {
          this.ventasDiariasFacturaElectronica = this.ventasDiariasAll.filter((item) => item.factura == this.facturapos )
        }
        this.isLoading = true
        this.loaderDian.emit(1)
        let doceCantidadItems: number = this.ventasDiariasFacturaElectronica.length
        let forpCodigo: number = 1

        let doeaPais: string = 'CO'

        let identificacion: string = this.ventasDiariasFacturaElectronica[0].identificacion
        let doeaDireccion: string = this.ventasDiariasFacturaElectronica[0].direccion === '' ? 'Antioquia' : this.ventasDiariasFacturaElectronica[0].direccion
        let doetCodigo: string = queHago ? '20' : '20'
        let tipoCodigo: string = this.ventasDiariasFacturaElectronica[0].tipoVenta == 'O' ? '10' : '10'
        let doeaRazonSocial: string = this.ventasDiariasFacturaElectronica[0].cliente
        let doeaCorreo: string = this.ventasDiariasFacturaElectronica[0].correo === null ? 'sanrestapp@gmail.com' : this.ventasDiariasFacturaElectronica[0].correo
        let doeaTelefono : string = this.ventasDiariasFacturaElectronica[0].numeroTelefono
        let tidtCodigo:  string = this.ventasDiariasFacturaElectronica[0].tipoIdentificacion == "C" || this.ventasDiariasFacturaElectronica[0].tipoIdentificacion == ""  ? '13' : "31"
        let tiotCodigo: number = this.ventasDiariasFacturaElectronica[0].tipoIdentificacion == "C" ? 2 : 1
        let doeaDiv: string = this.ventasDiariasFacturaElectronica[0].tipoIdentificacion == "C" ? '0' : '1'
        let dempCodigo: string = this.ventasDiariasFacturaElectronica[0].tipoVenta == 'O' ? '10' : '42'
        if(doeaDiv === '1') {
          doeaDiv = this.ventasDiariasFacturaElectronica[0].digito
        }
         if(dempCodigo === '42') {
          if(this.ventasDiariasFacturaElectronica[0].tipoVenta === 'C') {
            dempCodigo = 'ZZZ'
          }
        }

        let doetSubtotal: number = 0;
          let ImpuestosLineafor = []
          for(let i = 0; i< this.ventasDiariasFacturaElectronica.length;i++) {
          this.ImpuestosLinea = []
          if(this.ventasDiariasFacturaElectronica[i].valorImpuestoCalculado > 0) {
            this.ImpuestosLinea.push({

              "DoeiTotal": this.ventasDiariasFacturaElectronica[i].valorImpuestoCalculado , // doeiTotal
              "DoeiEsPorcentual": 1,
              "ImpuCodigo": this.ventasDiariasFacturaElectronica[i].tipoImpuesto === 'I' ? '04' : '01' , //impuCodigo,
              "Detalle": [
                  {
                      "DediBase": this.ventasDiariasFacturaElectronica[i].valorBase, //dediBase,
                      "DediValor": this.ventasDiariasFacturaElectronica[i].valorImpuestoCalculado,
                      "DediFactor": this.ventasDiariasFacturaElectronica[i].porcentajeImpuesto,
                      "UnimCodigo": "94"
                  }
              ]
          })
      }

        let porcentajeImpuesto: boolean = false
        let valorImpuestoDediValor: number = 0
        if(this.ImpuestosLinea && this.ImpuestosLinea[0] && this.ImpuestosLinea[0].Detalle[0] && this.ImpuestosLinea[0].Detalle[0].DediFactor > 0) {
          porcentajeImpuesto = true
          valorImpuestoDediValor = this.ImpuestosLinea[0].Detalle[0].DediValor
          ImpuestosLineafor.push(...this.ImpuestosLinea)
        }
        this.ventasDiariasFacturaElectronica[i].tipoIdentificacion = this.ventasDiariasFacturaElectronica[i].tipoIdentificacion == " " ? 'N' : 'J'
        this.ventasDiariasFacturaElectronica[i].tipoIdentificacion = this.ventasDiariasFacturaElectronica[i].tipoIdentificacion == " " ? 'C' : this.ventasDiariasFacturaElectronica[i].tipoIdentificacion


        let doeiCodigo : string = this.ventasDiariasFacturaElectronica[i].codigoProducto
        let doeiDescripcion : string = this.ventasDiariasFacturaElectronica[i].nombreProducto
        let doeiCantidad : number = this.ventasDiariasFacturaElectronica[i].cantidad
        let doeiPrecioUnitario : number = this.ventasDiariasFacturaElectronica[i].valorUnitario
        let DoeiBase : number = this.ventasDiariasFacturaElectronica[i].valorBase

        this.DetalleFactura.push(
          {
            "DoeiItem": i + 1, /** 1 Debe ser un valor consecutivo empezando en 1. El máximo valor debe ser igual al valor de DoceCantidadItems. */
            "DoeiCodigo": doeiCodigo, /** Indica el codigo del Producto o del Servicio Facturado. Si se usa estandar Colombia compra eficiente es el codigo de producto de la codificación. */
            "DoeiDescripcion": doeiDescripcion, /** Indica la descripción del Bien o Servicio facturado. */
            "DoeiMarca": '',
            "DoeiModelo": '',
            "DoeiObservacion": '',
            "DoeiDatosVendedor": '',
            "DoeiCantidad": doeiCantidad, /** Indica la Cantidad de producto y/o servicio del item. Este Valor debe estar redondeado a 2 decimales Segun Algoritmo Propuesto por la DIAN y ser mayor a cero. */
            "DoeiCantidadEmpaque": 1,
            "DoeiEsObsequio": 0, /** Indica si la Linea es Obsequio o No. DoeiEsObsequio=1 es obsequio. Para este tipo de items se debe dar un precio de referencia para el cálculo de los Impuestos al igual que un tipo de precio de referencia. Por defecto es 0 */
            "DoeiPrecioUnitario": doeiPrecioUnitario, /** Indica el precio unitario del producto y/o servicio. Para el caso de los obsequios este valor debe ser 0. */
            "DoeiPrecioReferencia": 0,
            "DoeiValor": porcentajeImpuesto ? DoeiBase : doeiCantidad * doeiPrecioUnitario, /** doeiCantidad * doeiPrecioUnitario, *//** + IMPUESTO LINEA Indica el valor total de la Linea. DoeiCantidad*(DoeiPrecioUnitario + (DoeiPrecioReferencia*DoeiEsObsequio)) . No olvidar que cuando DoeiEsObsequio=1 DoeiPrecioUnitario debe ser igual ha cero. */
            "DoeiTotalDescuentos":0,
            "DoeiTotalCargos": 0, /** Indica la suma de todos los Cargos aplicados al Item. Debe ser igual a la Sumatoria de todos los DecdValor DecdEsdescuento=0 de la lista de cargos del item. Estos valores se envian cuando el cargo descuento afecta la base de los impuesto. */
            "DoeiTotalImpuestos": valorImpuestoDediValor == undefined ?  0 : valorImpuestoDediValor, /** Indica el total de impuestos aplicados al item. Es igual a la sumatoria de todos los DoeiTotal de la lista de impuestos del Item. */
            "DoeiBase": porcentajeImpuesto ? DoeiBase : 0, /** Indica la Base que se utiliza para el calculo de los impuestos del item. Se calcula de la Siguiente Manera:(DoeiCantidad*(DoeiPrecioUnitario + (DoeiPrecioReferencia*DoeiEsObsequio)) )-DoeiTotalDescuentos+DoeiTotalCargos. No siempre es el mismo valor de DoeiSubtotal */
            "DoeiSubtotal": porcentajeImpuesto ? DoeiBase : doeiCantidad * doeiPrecioUnitario, //**  doeiCantidad * doeiPrecioUnitario*/ /** Indica el subtotal del Item. Es igual a: DoeiPrecioUnitario*DoeiCantidad. Para el caso de los obsequios este valor debe Cero. */
            "TicpCodigo": '999', /** Indica el tipo de codificacion que usara el item: 001 UNSPSC-Colombia Compra Eficiente (Apartado 8.1). 999 Estándar de adopción del contribuyente. 020 Partida Arancelarias. 010 GTIN-Números Globales de Identificación de Productos. ver Apartado 6.3.5. se puede usar el comodin 999 */
            "UnimCodigo": '94',
            "CtprCodigo": '02',
            "ImpuestosLinea": this.ImpuestosLinea
          })

          doetSubtotal+= this.ventasDiariasFacturaElectronica[i].valorBase
        }

      if(this.ImpuestosLinea.length === 1 && this.ventasDiariasFacturaElectronica[0].tipoImpuesto === 'I') {
        //   this.ImpuestosLinea.push({

        //     "DoeiTotal": 0 , // doeiTotal
        //     "DoeiEsPorcentual": 1,
        //     "ImpuCodigo": '01' , //impuCodigo,
        //     "Detalle": [
        //         {
        //             "DediBase": this.ventasDiariasFacturaElectronica[0].valorBase, //dediBase,
        //             "DediValor": 0,
        //             "DediFactor": 0,
        //             "UnimCodigo": "94"
        //         }
        //     ]
        // })

      } else {
        if(this.ImpuestosLinea.length === 1 && this.ventasDiariasFacturaElectronica[0].tipoImpuesto !=="I") {
        //   this.ImpuestosLinea.push({

        //     "DoeiTotal": 0 , // doeiTotal
        //     "DoeiEsPorcentual": 1,
        //     "ImpuCodigo": '04' , //impuCodigo,
        //     "Detalle": [
        //         {
        //             "DediBase": this.ventasDiariasFacturaElectronica[0].valorBase, //dediBase,
        //             "DediValor": 0,
        //             "DediFactor": 0,
        //             "UnimCodigo": "94"
        //         }
        //     ]
        // })
        }
      }


      let doeiTotalIva = 0
      let doeiTotalIva19 = 0
      let doeiTotalIva5 = 0
      let doeiTotalIco = 0
      let dediFactorIva19 = 0
      let dediFactorIva5 = 0
      let dediFactorIco = 0
      let dediBaseIva = 0
      let dediBaseIva19 = 0
      let dediBaseIva5 = 0
      let dediBaseIco = 0

      ImpuestosLineafor.forEach((data: any, index, number) => {
        if(data.ImpuCodigo == "04") {
          doeiTotalIco += data.DoeiTotal
          dediFactorIco = data.Detalle[0].DediFactor
        } else {
          if(data.Detalle && data.Detalle[0] && data.Detalle[0].DediFactor == 19) {
            dediFactorIva19 = data.Detalle[0].DediFactor
            dediBaseIva19+= data.Detalle[0].DediBase
            doeiTotalIva19+= data.DoeiTotal
          } else {
            dediFactorIva5 = data.Detalle[0].DediFactor
            dediBaseIva5+= data.Detalle[0].DediBase
            doeiTotalIva5+= data.DoeiTotal
          }
        }
        // dediBaseIva  += data.ImpuCodigo === '01' ? data.Detalle[0].DediBase : 0
        dediBaseIco  += data.ImpuCodigo !== '01' ? data.Detalle[0].DediBase : 0
      })

      if(dediFactorIva19 == 19 && dediFactorIva5== 5) {
        this.impuestosFactura = [
          {
              "DoeiTotal": doeiTotalIva19 + doeiTotalIva5,
              "DoeiEsPorcentual": 1,
              "ImpuCodigo": '01',
              "Detalle": [
                  {
                      "DediBase": dediBaseIva19,
                      "DediValor": doeiTotalIva19,
                      "DediFactor": dediFactorIva19,
                      "UnimCodigo": "94"
                  },
                  {
                    "DediBase": dediBaseIva5,
                    "DediValor": doeiTotalIva5,
                    "DediFactor": dediFactorIva5,
                    "UnimCodigo": "94"
                }
              ]
          }
      ]

      }

      if(dediFactorIva19 == 19 && dediFactorIva5 ==0) {
        this.impuestosFactura = [
          {
              "DoeiTotal": doeiTotalIva19,
              "DoeiEsPorcentual": 1,
              "ImpuCodigo": '01',
              "Detalle": [
                  {
                      "DediBase": dediBaseIva19,
                      "DediValor": doeiTotalIva19,
                      "DediFactor": dediFactorIva19,
                      "UnimCodigo": "94"
                  }
              ]
          }
      ]

      }

      if(dediFactorIva19 == 0 && dediFactorIva5 == 5) {
        this.impuestosFactura = [
          {
              "DoeiTotal": doeiTotalIva5,
              "DoeiEsPorcentual": 1,
              "ImpuCodigo": '01',
              "Detalle": [
                {
                  "DediBase": dediBaseIva5,
                  "DediValor": doeiTotalIva5,
                  "DediFactor": dediFactorIva5,
                  "UnimCodigo": "94"
                }
              ]
          }
      ]

      }


      if(doeiTotalIco> 0) {
        this.impuestosFactura = [
          {
            "DoeiTotal": doeiTotalIco,
            "DoeiEsPorcentual": 1,
            "ImpuCodigo": '04',
            "Detalle": [
                {
                    "DediBase": dediBaseIco,
                    "DediValor": doeiTotalIco,
                    "DediFactor": dediFactorIco,
                    "UnimCodigo": "94"
                }
            ]
        }
      ]

      }

      /*
        INICIO ICA Y RETEICA
      */
        let manejaIca = false
        let manejaReteIca = false
        let datosGenerales = localStorage.getItem('datosGenerales')
        let datosGeneralesJSON = JSON.parse(datosGenerales)
        if(datosGeneralesJSON && datosGeneralesJSON["manejaIca"]) {
          manejaIca = datosGeneralesJSON["manejaIca"].seleccion === 'S' ? true : false
        }

        if(datosGeneralesJSON && datosGeneralesJSON["manejaReteIca"]) {
          manejaReteIca = datosGeneralesJSON["manejaReteIca"].seleccion === 'S' ? true : false
        }
        if (manejaIca || manejaReteIca) {
          let companiasId = await localStorage.getItem('companiasId');
          let ICA: any = await this.dian.calcularIca(companiasId, this.facturapos);
          let responseJsonICA = JSON.parse(ICA['_body']);

          // Verificar si existen registros en responseJsonICA.data
          if (responseJsonICA.data && responseJsonICA.data.length > 0) {
            // Limpiar impuestosFactura solo si hay registros válidos
            this.impuestosFactura = [];

            // Recorrer todos los subarrays de datos
            responseJsonICA.data.forEach((subarray: any) => {
              if (subarray && subarray.length > 0) {
                // Recorrer cada elemento dentro del subarray
                subarray.forEach((responseICABodyJson: any) => {
                  console.log('Procesando registro:', responseICABodyJson);

                  // Crear el nuevo objeto de impuesto
                  const nuevoImpuesto = {
                    "DoeiTotal": responseICABodyJson.DoeiTotal,
                    "DoeiEsPorcentual": responseICABodyJson.DoeiEsPorcentual,
                    "ImpuCodigo": responseICABodyJson.ImpuCodigo,
                    "Detalle": [
                      {
                        "DediBase": responseICABodyJson.DediBase,
                        "DediValor": responseICABodyJson.DediValor,
                        "DediFactor": responseICABodyJson.DediFactor,
                        "UnimCodigo": responseICABodyJson.UnimCodigo
                      }
                    ]
                  };

                  // Agregar el objeto al array impuestosFactura
                  this.impuestosFactura.push(nuevoImpuesto);
                });
              }
            });
          }

        }
        /**
         * FIN ICA Y RETEICA
        */

        let id =   UUID.UUID()
        let observacion = []
        observacion.push(descripcionFactura)
        let doceFecha =  new Date(); // Crear objeto de fecha
        doceFecha.setHours(doceFecha.getHours() - 5); // Restar 5 horas

        let dataFactura: poselectronico = {
          Solicitud: {
            Nonce: id,
            Suscriptor: this.suscriptorDian
          },
           DocumentoEquivalente: {
            Cabecera: {
              DoceCantidadItems: doceCantidadItems, /** 1 Indica la cantidad de items o lineas de productos presentes en el detalle de la factura. */
              DoceConsecutivo: Number(this.setPruebasFacturaElectronica) ? 'EPOS10' : this.resolucionDian.trim(), /** 'SETT0001'= ambiente pruebas 'FV0001' Indica el numero del documento incluido el prefijo. Ejemplo: FV0001 */
              DoceFecha: doceFecha, /** "2023-04-01T17:07:22.397177-05:00" Permite Cargar la fecha del documento. el Formato es: Año-Mes-Día Hora militar:Minutos:Segundos AAAA-MM-DD HH:MM:SS 2020-12-01 06:58:42. Si este campo no es enviado se toma la fecha actual del sistema KIAI. Tener presente que se debe enviar una fecha menor a la actual en http://horalegal.inm.gov.co/ para que la Dian no rechace el documento por ser firmado en el futuro. IMPORTANTE: no enviar documentos con fechas menores al rango permitido por la Dian. El uso de este campo queda bajo la responsabilidad del emisor del Documento. E deber ser es usar siempre la fecha actual del sistema del proveedor. */
              DoceLineasWhatsApp:'', /** Permite indicar que el documento sera notificada por WhatsApp a los numeros contenidos en dicho campo. Si no va a notificar por WhatsApp no enviar o enviar NULL. Debe Tener la siguiente estructura: {'codigopais'+'linea'+';'}. El codigopais deber ser estandar de 3 digitos, la linea es el numero telfónico de 10 numeros finalizando con ; . 0570000000000; Se podran Cargar hasta 5 lineas para notificación por Factura */
              DoceManejaPeriodos:0, /** Indica si el documento maneja periodos. 1 Si maneja. 0 No maneja. Esta Condición normalmente se utiliza en las facturas de serivicios publicos */
              DocePrefijo: '', /** Indica el prefijo de la resolución a usar. Se debe enviar para los casos en los que un número de resolucion Dian tiene muchos prefijos asociados al mismo nuemro de resolución */
              DoetCodigo: doetCodigo, /** '01'=factura '91'=nota crédito anular factura Indica el tipo de Documento Electronico. Ver Apartado 6.1.3. 01 Factura de Venta Nacional. 91 Nota Crédito */
              EnviarSetPruebas: Number(this.setPruebasFacturaElectronica) ? 0 : 1, /** Indica si se desea enviar o no el identificador de set de pruebas al servicio de validación previa. Una vez finalizado el proceso de habilitacion, si se desean emitir documentos de prueba a la dian, se debe enviar un 0 */
              MoneCodigo: 'COP', /** Indica el tipo de moneda del documento electrónico. (ISO 4217) Ver Apartado 6.3.3. Peso Colombiano COP */
              RefvNumero: Number(this.resolucionDian),  /** this.resolucionDian 0 Indica el número de resolución de facturación de venta. Es Obligatorio para el caso de las Facturas de venta. Este Numero es asignado por la Dian */
              TipoCodigo: tipoCodigo, /** ' 10 = estandar 20 = nota crédito que es anulación Indica el tipo de operación al que pertenece el Documento. 05 Generica Etc Ver Apartado 6.1.5. Tipos de operación */
              AmbdCodigo: Number(this.setPruebasFacturaElectronica) ? '2': '1',
              DoceReferenciaPago: ""
            },
            PagosFactura: {
              ForpCodigo: forpCodigo, /** 1 Codigo de la forma de pago. Contado o Credito. ver apartado 6.3.4.1. 1. Contado 2. Crédito */
              DoepFechaVencimiento: new Date(), /** Cuando es a credito se deben enviar la fecha de vencimiento. por defecto es la fecha actual mas 30 dias. */
              Medios: [{
                DempCodigo: dempCodigo, /* '30' transferencia crédito '31' transferencia débigo '42' consignación bancaria '10' efectivo '01' anexo 1.8 factura electronica Indica el código del medio de pago. Ver apartado 6.3.4.2. Se puede usar como Comodin 01 y ZZZ */
                DempDescripcion: dempCodigo/** Permite Cargar el valor pagado o cualquier texto libre. Se Admite el simbolo de moneda ($) y separadores de miles y decimales. */
              }]
            },
            AdquirienteFactura: {
              DoeaEsResponsable: 0, /** Este campo permite indicar si es un adquiriente responsable o no. 1 Es responsable y 0 no es responsable. Adquiriente resposable es aquel que esta obligado a emitir facturas electrónicas por ende esta obligado a recibirlas tambien de manera electrónica. El adquiriente responsable debe indicar en el catalogo de participantes de la Dian cual va hacer el mecanismo de recpeción de facturas. */
              DoeaEsnacional: 1, /** Indica si el Adquiriente o Comprador es Colombiano o Extranjero. 1 si es Colombiano y 0 Para Extranjero. Esta entrada modifica el cobro de algunos impuestos y hace obligatorio o no el uso de codigo postal en las direcciones. Para Nacionales es obligatorio indicar el codigo Postal en el campo correspondiente. */
              DoeaDocumento: identificacion,  /** Indica el documento del adquiriente o Comprador. Puede ser el numero de nit, de cedula, Documento extranjero, Pasaporte etc.*/
              DoeaDiv: doeaDiv, /** Indica el dígito de verificación del NIT. Aplica solo para tipo de documento NIT. */
              DoeaRazonSocial: doeaRazonSocial, /** '' Indica la razón solcial del adquiriente */
              DoeaNombreCiudad: '', /** '0' Indica el nombre de la ciudad del adquiriente. se debe enviar solo cuando el adquiriente no es nacional, DoeaEsnacional=0. */
              DoeaNombreDepartamento: '', /** Indica el nombre del departamento o la provincia del adquiriente. se debe enviar solo cuando el adquiriente no es nacional, DoeaEsnacional=0. */
              DoeaPais: doeaPais, /** Indica el País del adquiriente. Ver Apartado 6.4.1 (ISO 3166-1) Se utiliza Codigo de dos dígitos. Para Colombia es CO */
              DoeaDireccion: doeaDireccion, /** Indica la dirección del adquiriente */
              DoeaObligaciones: '', /** Indica las Responsabilidades, calidades y atributos del adquiriente. Aplica solo para los adquirientes con documento tipo NIT. Estos son los codigos que aparecen en rut de adquiriente en la casilla 53. si se cuenta con varias se deben enviar separadas por; se permiten solo los valores del apartado 6.2.7. Puede usar como Comodin O-99 */
              DoeaNombres: '', /** Indica los nombres del adquiriente. Aplica solo para las personas naturales. Si tiene segundo nombre va tambien en este campo */
              DoeaApellidos: '',
              DoeaOtrosNombres: '',
              DoeaCorreo: (doeaCorreo == undefined || doeaCorreo == "null") ? '' : doeaCorreo, /** Indica el correo del adquiriente. Los correos de este campo seran a los que les llegue la factura. Se pueden cargar varios correos separados por ;	*/
              DoeaTelefono: doeaTelefono,
              TiotCodigo: tiotCodigo, /** Indica el tipo de persona u organizacion tributaria. Tipo de persona. 1 Juridica,2 Natural Ver Apartado 6.2.3. */
              CopcCodigo: '050001',
              RegCodigo: '49', /** Indica el Régimen tributario del adquiriente. Solo Existen Dos Posibles Opciones 48 Responsable de iva o 49 No responsable de iva */
              TidtCodigo: tidtCodigo, /** Indica el tipo de Documento Tributario. 31 NIT. 13 Cedula Ver Apartado 6.2.1 */
              DoeaManejoAdjuntos: (doeaCorreo == undefined || doeaCorreo == "null") ? 1 : 0, /** Indica si se va a usar PDF personalizado para la representación Gráfica. 1 PDF personalizado, 0 PDF genérico . Por defecto sera 0 */
              DoeaProcedencia: '01',
              CalcularDv: 0 /** Indica si se desea que Kiai calcule el digito de verificación del nit del vendedor o adquiriente */
            },
            DetalleFactura: this.DetalleFactura
            ,
            ResumenImpuestosFactura: {
              DeriTotalIva: doeiTotalIva19 + doeiTotalIva5, //doeiTotalIva, /** Indica el total del impuesto de IVA, presente en el documento. Si no esta presente se debe enviar cero 0 */
              DeriTotalConsumo: doeiTotalIco, // ,  /** Indica el total del impuesto al CONSUMO, presente en el documento. Si no esta presente se debe enviar cero 0 */
              DeriTotalIca: 0, /** Indica el total del impuesto de ICA, presente en el documento. Si no esta presente se debe enviar cero 0 */
            },
            TotalesFactura: {
              DoetSubtotal: doetSubtotal, /** doetSubtotal Indica la suma de los valores brutos de las líneas de la factura. Ver apartado FAU01 LegalMonetaryTotal => FAU02 LineExtensionAmount */
              DoetTotalImpuestos:doeiTotalIva19 + doeiTotalIva5 + doeiTotalIco, // doeiTotalIva + doeiTotalIco, /** Indica el total de todos los impuestos presentes en el documento. */
              DoetBase: (doeiTotalIva19 + doeiTotalIva5 + doeiTotalIco) > 0 ? dediBaseIco + dediBaseIva19 + dediBaseIva5: 0, /** Base imponible para el cálculo de los tributos. Ver apartado FAU01 LegalMonetaryTotal => FAU04 TaxExclusiveAmount */
              DoetSubtotalMasImpuestos: doetSubtotal + (doeiTotalIva19 + doeiTotalIva5 + doeiTotalIco) ,//doetTotalDocumento , /** Indica la Suma de DoetSubtotal+DoetTotalImpuestos. Ver apartado FAU01 LegalMonetaryTotal => FAU06 TaxInclusiveAmount */
              DoetTotalDescuentos: 0, /** Indica la suma de todos los descuentos aplicados a nivel de factura, es decir los descuentos globales que han afectado las bases de los impuestos. Ver apartado FAU01 LegalMonetaryTotal => FAU08 AllowanceTotalAmount */
              DoetTotalcargos: 0, /** indica la suma de todos los cargos aplicados a nivel de la factura. Ver apartado FAU01 LegalMonetaryTotal => FAU10 ChargeTotalAmount */
              DoetTotalAnticipos: 0, /** Indica la suma de todos los pagos anticipados del documento. Ver apartado FAU01 LegalMonetaryTotal => FAU12 PrePaidAmount */
              DoetAjusteAlPeso: 0, /** Indica el valor de ajuste al total de documento. Este campo puede ser usado para evitar decimales en el total del documento. Puede ser valores negativos. Para Ajustar el valor DoetTotalDocumento de 9999.99 a 10000 el valor de DoetAjusteAlPeso debe ser 0.01 y DoetTotalDocumento debe ser 10000 */
              DoetTotalDocumento: doetSubtotal + (doeiTotalIva19 + doeiTotalIva5  + doeiTotalIco)  //doetSubtotal //doetTotalDocumento /** Indica el total a pagar de la factura. Este valor es calculado de la siguiente manera : DoetSubtotalMasImpuestos -DoetTotalDescuentos +DoetTotalcargos-DoetTotalAnticipos ó Valor total de ítems(incluyendo cargos+ y descuentos- a nivel de ítems)+DoetTotalImpuestos + DoetTotalcargos – DoetTotalDescuentos – DoetTotalAnticipos. Ver apartado FAU01 LegalMonetaryTotal => FAU14 PayableAmount */
            },
            ImpuestosFactura:this.impuestosFactura,
            Observaciones: observacion,
            Extensiones: {
              ExtensionesPOS: {
                FabricanteSoftware: {
                  NombreApellido: DEETDMRCSP_POS_NOMBRE_APELLIDO,
                  RazonSocial: DEETDMRCSP_POS_RAZON_SOCIAL,
                  NombreSoftware: DEETDMRCSP_POS_NOMBRE_SOFTWARE,
                  NIT: DEETDMRCSP_POS_NIT
                },
                BeneficiosComprador: {
                  Codigo: "0",
                  NombresApellidos: this.nombreIntegrado,
                  Puntos: "0"
                },
                InformacionCajaVenta: {
                  PlacaCaja: "SAN",
                  UbicaciónCaja: "1",
                  Cajero: "1",
                  TipoCaja: "SAN",
                  CodigoVenta: "1",
                  SubTotal: "0"
                },
                MontoOperacion: {
                  CantidadNominal: 0,
                  PrecioRegistro: 0,
                  MontoDeRendimientos: 0,
                  Valor: 0,
                  PorcentajeComision: 0
                }
              }
            }
          }
        }
        // DEETDMRCSP_POS_URL_CREAR_SET_PRUEBA
        let ambientePrueba: string = Number(this.setPruebasFacturaElectronica) ? 'S': 'N'
        this.dian.devolverDatosFacturaElectronicaResumenSuscriptorPorCompania(this.companiasId, ambientePrueba).subscribe(
          res => {
            if(NUBE_AWS) {
              let responseConsecutivoFacturacion = JSON.parse(res['_body']).data[0][0]

              if(responseConsecutivoFacturacion == undefined ) {
                this.utils.mensajeMuestro('Para poder generar el pos electrónica, debe crear la resolución en la Dian','Advertencia!','advertencia')
                this.isLoading = false
                this.loaderDian.emit(this.isLoading)
                return
              }
              let prefijoDian = responseConsecutivoFacturacion.deetdmrcspPrefijoDian
              let resumenSuscriptor = responseConsecutivoFacturacion
              let fechaActual: Date = new Date()
              let vigenciaDesde = new Date(resumenSuscriptor.deetdmrcsPvigenciaDesde)
              let vigenciaHastaDian = new Date(resumenSuscriptor.deetdmrcsPvigenciaHasta)
              if(fechaActual < vigenciaDesde || fechaActual > vigenciaHastaDian) {
                this.utils.mensajeMuestro('Para poder generar el Documento equivalente electrónico tiquete de máquina registradora con sistema P.O.S, debe actualizar la resolución de la Dian las fechas ya no son validas','Advertencia!','advertencia')
                this.isLoading = false
                this.loaderDian.emit(this.isLoading)
                return
              }

              let consecutivoAtualDian: Number = Number(resumenSuscriptor.deetdmrcsPconsecutivoAtual)
              let consecutivoHastaDian: Number = Number(resumenSuscriptor.deetdmrcsPconsecutivoHasta)

              if( consecutivoAtualDian > consecutivoHastaDian) {
                this.utils.mensajeMuestro('Para poder generar el Documento equivalente electrónico tiquete de máquina registradora con sistema P.O.S, debe crea una nueva resolución en la Dian; actualmente supero la cantidad máxima permitida de consecutivos','Advertencia!','advertencia')
                return
              }
              let consecutivoPruebas: Number = Number(this.setPruebasFacturaElectronica) ? Number(consecutivoAtualDian) : 0
              // dataFactura.DocumentoEquivalente.Cabecera.DoceConsecutivo = Number(this.setPruebasFacturaElectronica) ? resumenSuscriptor.deetdmrcspPrefijoDian.trim() + consecutivoPruebas.toString() : prefijoDian.trim() + consecutivoAtualDian.toString().trim()
              dataFactura.DocumentoEquivalente.Cabecera.DoceConsecutivo = Number(this.setPruebasFacturaElectronica) ? resumenSuscriptor.deetdmrcspPrefijoDian.trim() + consecutivoPruebas.toString() : resumenSuscriptor.deetdmrcspPrefijoDian.trim() + consecutivoAtualDian.toString().trim()

              dataFactura.DocumentoEquivalente.Cabecera.RefvNumero = Number(this.setPruebasFacturaElectronica) ? this.resolucionDian :  resumenSuscriptor.deetdmrcsPresolucionDian;
              if(!queHago) {
                dataFactura.DocumentoEquivalente.Cabecera.DoceConsecutivo = this.numeroFacturaElectronica.trim()
                // let prefijoDian =  this.prefijoDian !== undefined ? this.prefijoDian.trim() : this.prefijoDian
                let facturaPOSDIAN = this.facturaPOSDIAN
                dataFactura.DocumentoEquivalente['DocumentoReferencia'] = {
                  "DedrDocumentoReferencia": facturaPOSDIAN,
                  "CodigoConcepto": "2"
                }
                dataFactura.DocumentoEquivalente.Cabecera.DoetCodigo = "94"
                dataFactura.DocumentoEquivalente.Cabecera.TipoCodigo = "20"
                dataFactura.DocumentoEquivalente.Cabecera.DoceConsecutivo = "NC" + dataFactura.DocumentoEquivalente.Cabecera.DoceConsecutivo
                console.log('DedrDocumentoReferencia', dataFactura)
                dataFactura.DocumentoEquivalente['AdquirienteFactura'].DoeaObligaciones = "R-99-PN"
              }
              this.dian.devolverDatosPosElectronica(dataFactura, this.setPruebasFacturaElectronica).subscribe(
                res => {
                        if(res.Control.CufeCude !== null ) {
                          let cufe = res.Control.CufeCude
                          let documento = res.Carga.DoceConsecutivo

                          // let documentoObjeto = CadenaCodigoQrObjetSlice[0].split(':')
                          // let documentoCadena = documentoObjeto[1]
                          // documentoCadena = documentoCadena === "" ?  documentoObjeto[2] : documentoCadena
                          // let documento = documentoCadena.replace(/\D/g, '')
                          // let subTotalObjeto = CadenaCodigoQrObjetSlice[3].split(':')
                          // let subTotal = subTotalObjeto[1]
                          // subTotal = subTotal === "" ?  subTotalObjeto[2] : subTotal
                          // let totalImpuestosObjeto = CadenaCodigoQrObjetSlice[5].split(':')
                          // let totalImpuestos = totalImpuestosObjeto[1]
                          // totalImpuestos = totalImpuestos === "" ?  totalImpuestosObjeto[2] : totalImpuestos
                          // let totalObjeto = totalImpuestos !== "" ? CadenaCodigoQrObjetSlice[5].split(':') : CadenaCodigoQrObjetSlice[8].split(':')
                          // let total = totalObjeto[1]
                          // total = total === "" ?  totalObjeto[2] : total
                          this.nombreIntegrado = data.cliente
                          this.identificacion = data.identificacion
                          let fechaActualCadena = ''
                          const fecha = new Date();

                          // Obtiene el año, mes y día de la fecha actual
                          const anio = fecha.getFullYear();
                          const mes = fecha.getMonth() + 1; // Los meses van de 0 a 11, por eso se suma 1
                          const dia = fecha.getDate();

                          // Construye la cadena con el formato deseado (YYYYMMDD)
                          fechaActualCadena = anio.toString() + this.padLeftZero(mes.toString(), 2) + this.padLeftZero(dia.toString(), 2);

                          let entidadFactura: factura = {
                            companiasId:Number(this.companiasId),
                            fechaFactura:fechaActualCadena,
                            documento:documento,
                            factura:JSON.stringify(this.facturapos),
                            formaPago:'Contado',
                            subtotal:Number(0),
                            totalImpuestos:Number(0),
                            total:Number(0),
                            estado:'',
                            prefijo:res.Carga.DoceId,
                            setPruebasFacturaElectronica:ambientePrueba,
                            nit: this.identificacion === undefined ? 222222222 : Number(this.identificacion),
                            cliente:this.nombreIntegrado == undefined ? 'Consumidor final' : this.nombreIntegrado,
                            tipo: 'DEETDMRCSP',
                            cufe:cufe
                          }
                          this.cufe = cufe
                          this.valoresCufe(this.cufe);

                          this.utils.mensajeMuestro(res.Validaciones.mensaje,'Guardado Exitosamente!','success')

                          this.dian.updateConsecutivosPosDian(this.companiasId, ambientePrueba,consecutivoAtualDian)
                          .subscribe(
                            res => {
                              let entidadFacturacionRequest = {
                                ...entidadFactura,
                                queHago: "I",
                                name: 'dataDynamicCrud',
                                nombreTabla: "logFacturasElectronicas"
                              }

                              this.servicioEntidades.guardarLogPosElectronica(entidadFacturacionRequest)
                              .subscribe(
                                res => {
                                  this.limpiarFactura()
                                  this.buscarVentasdiariasCajaDeetdmrcs(entidadFactura.factura)
                                  console.log('consecutivo actualizado con exito')
                                },
                                err => {
                                  this.isLoading = false
                                  this.loaderDian.emit(this.isLoading)
                                  console.log(err)}
                              )

                            },
                            err => {
                              this.limpiarFactura()
                              console.log('el consecutivo no se actualizo verifique')
                            })

                        } else {
                          this.limpiarFactura()
                          let mensaje = ''
                          let DoceId = ''
                          if(res !== undefined && res['Validaciones'] !== undefined && res['Validaciones']['Detalle'] !== undefined && res['Validaciones']['Detalle'].length > 0) {
                            for(let i=0; i< res['Validaciones']['Detalle'].length;i++) {
                              mensaje += res['Validaciones']['Detalle'][i].Validacion + '\n'
                              DoceId = res['Validaciones'].DoceId
                            }
                            mensaje += 'DoceId: ' + '\n' + DoceId
                            this.utils.mensajeMuestro(mensaje,'Advertencia!','advertencia')
                            this.isLoading = false
                            this.loaderDian.emit(this.isLoading)
                            return
                          }
                          if(queHago){
                            mensaje = "el Documento equivalente electrónico tiquete de máquina registradora con sistema P.O.S no se logro general debe intentar en unos mínutos",'Advertencia!'
                            if(res !== undefined && res['Validaciones'] !== undefined && res['Validaciones']['mensaje'] !== undefined) {
                              mensaje = ""
                              mensaje += "el Documento equivalente electrónico tiquete de máquina registradora con sistema P.O.S no se logro general por causa de: " + '\n'
                              mensaje += res['Validaciones']['mensaje'] + '\n'
                              if(res['Carga'] !== undefined && res['Carga']['DoceId'] !== undefined) {
                                DoceId = res['Carga'].DoceId
                                mensaje += 'id: ' + '\n' + DoceId
                              }
                            }
                           this.utils.mensajeMuestro(mensaje,'Advertencia!','warning')
                            console.log('el Documento equivalente electrónico tiquete de máquina registradora con sistema P.O.S no se logro general debe intentar en unos mínutos', res)
                          } else {
                            this.utils.mensajeMuestro("el Documento equivalente electrónico tiquete de máquina registradora con sistema P.O.S no se logro eliminar debe intentar en unos mínutos",'Advertencia!','advertencia')
                            console.log('el Documento equivalente electrónico tiquete de máquina registradora con sistema P.O.S no se logro eliminar debe intentar en unos mínutos', res)
                          }
                        }},
                err => {
                  this.limpiarFactura()


                  let mensaje = ''
                  let DoceId = ''
                  if(res !== undefined && res['Validaciones'] !== undefined && res['Validaciones']['Detalle'] !== undefined && res['Validaciones']['Detalle'].length > 0) {
                    for(let i=0; i< res['Validaciones']['Detalle'].length;i++) {
                      mensaje += res['Validaciones']['Detalle'][i].Validacion + '\n'
                      DoceId = res['Validaciones'].DoceId
                    }
                    mensaje += 'DoceId: ' + '\n' + DoceId
                    this.utils.mensajeMuestro(mensaje,'Advertencia!','advertencia')
                    this.isLoading = false
                    this.loaderDian.emit(this.isLoading)
                    return
                  }
                  if(queHago){
                    this.utils.mensajeMuestro('el Documento equivalente electrónico tiquete de máquina registradora con sistema P.O.S no se logro general debe intentar en unos mínutos','Advertencia!','advertencia')
                    console.log('el Documento equivalente electrónico tiquete de máquina registradora con sistema P.O.S no se logro general debe intentar en unos mínutos', err)
                  } else {
                    this.utils.mensajeMuestro("el Documento equivalente electrónico tiquete de máquina registradora con sistema P.O.S no se logro eliminar debe intentar en unos mínutos",'Advertencia!','advertencia')
                    console.log('el Documento equivalente electrónico tiquete de máquina registradora con sistema P.O.S no se logro eliminar debe intentar en unos mínutos', err)
                  }

                })

            } else {
              this.limpiarFactura()
              this.utils.mensajeMuestro('Módulo en desarrollo','Advertencia!','advertencia')
              return
            }


          },
          err => {
            this.limpiarFactura()
            this.utils.mensajeMuestro("el Documento equivalente electrónico tiquete de máquina registradora con sistema P.O.S no se logro general debe intentar en unos mínutos",'Advertencia!','advertencia')
            console.log('el Documento equivalente electrónico tiquete de máquina registradora con sistema P.O.S no se logro general debe intentar en unos mínutos', err)
          }
        )
      }
    })
  }
  limpiar(){
    this.clienteId = []
    this.ImpuestosLinea = []
    this.impuestosFactura = []
  }

  limpiarFactura(){
    this.ImpuestosLinea = []
    this.impuestosFactura = []
    this.DetalleFactura = []
    this.isLoading = false;
    this.loaderDian.emit(this.isLoading)
    this.descripcionFactura = ''
  }

  mostrarMensajeAdvertencia(mensaje,titulo) {
    let alert = this.alertControllers.create({
      title: titulo,
      subTitle: mensaje,
      buttons: ['Cerrar']
    });
    alert.present();
  }
  padLeftZero(valor: string, longitud: number): string {
    return valor.length >= longitud ? valor : '0'.repeat(longitud - valor.length) + valor;
  }

  onPosClick(factura: any) {
    this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','companiasId', 'deetdmrcsPresolucionDian','deetdmrcspPrefijoDian',
    'deetdmrcsPmanejaFacturaElectronica','deetdmrcsPsetPruebasFacturaElectronica', 'deetdmrcsPsuscriptorDian'])
    .then((val)=>{
      if(val){
        this.nombreCompaniaHeader = val['nombreCompania']
        this.nombreCargoHeader = val['nombreCargo']
        this.companiasId = val['companiasId']
        this.resolucionDian =  val['deetdmrcsPresolucionDian'] == 'NULL' ? false : val['deetdmrcsPresolucionDian']
        this.prefijoDian = val['deetdmrcspPrefijoDian'] == 'NULL' ? false : val['deetdmrcspPrefijoDian']
        this.suscriptorDian = val['deetdmrcsPsuscriptorDian'] == 'NULL' ? '' : val['deetdmrcsPsuscriptorDian']
        this.manejaFacturaElectronica= val['deetdmrcsPmanejaFacturaElectronica'] == 'NULL' ? false : val['deetdmrcsPmanejaFacturaElectronica']
        this.setPruebasFacturaElectronica= val['deetdmrcsPsetPruebasFacturaElectronica'] == 'NULL' ? false : val['deetdmrcsPsetPruebasFacturaElectronica']
        this.push.buscarParametrosGenerales(this.companiasId).subscribe((data)=>{
            if(NUBE_AWS) {
              let valuesData = JSON.parse(data['_body']).data[0][0]
              this.visualizaDetalleReciboEnCaja = valuesData.visualizaDetalleReciboEnCaja === 'N' ? false : true;
            } else {
              this.visualizaDetalleReciboEnCaja = data[0][0].visualizaDetalleReciboEnCaja === 'N' ? false : true;
            }
        },(error)=>{
            console.log(error)
            this.isLoading= false;
            this.loaderDian.emit(this.isLoading)
        })

      }
    })
  }

 async cargarVariablesDeSesion() {
   this.isLoading = false;
   this.loaderDian.emit(this.isLoading)
   let val = await this.servicioCompania.devolverVariosAsync(['nombreCompania','nombreCargo','companiasId', 'deetdmrcsPresolucionDian','deetdmrcsPprefijoDian',
    'deetdmrcsPmanejaFacturaElectronica','deetdmrcsPsetPruebasFacturaElectronica', 'deetdmrcsPsuscriptorDian'])

    if(val){
        this.nombreCompaniaHeader = val['nombreCompania']
        this.nombreCargoHeader = val['nombreCargo']
        this.companiasId = val['companiasId']
        this.resolucionDian =  val['deetdmrcsPresolucionDian'] == 'NULL' ? false : val['deetdmrcsPresolucionDian']
        this.prefijoDian = val['deetdmrcsPprefijoDian'] == 'NULL' ? false : val['deetdmrcsPprefijoDian']
        this.suscriptorDian = val['deetdmrcsPsuscriptorDian'] == 'NULL' ? '' : val['deetdmrcsPsuscriptorDian']
        this.manejaFacturaElectronica= val['deetdmrcsPmanejaFacturaElectronica'] == 'NULL' ? false : val['deetdmrcsPmanejaFacturaElectronica']
        this.setPruebasFacturaElectronica= val['deetdmrcsPsetPruebasFacturaElectronica'] == 'NULL' ? false : val['deetdmrcsPsetPruebasFacturaElectronica']
        this.push.buscarParametrosGenerales(this.companiasId).subscribe((data)=>{
            if(NUBE_AWS) {
              let valuesData = JSON.parse(data['_body']).data[0][0]
              this.visualizaDetalleReciboEnCaja = valuesData.visualizaDetalleReciboEnCaja === 'N' ? false : true;
            } else {
              this.visualizaDetalleReciboEnCaja = data[0][0].visualizaDetalleReciboEnCaja === 'N' ? false : true;
            }
        },(error)=>{
            console.log(error)
            this.loaderDian.emit(this.isLoading)
            this.isLoading= false;
        })

      }
  }

  ngOnInit() {
    this.loaderDian.emit(this.isLoading)
    this.isLoading = false;
  }

  async valoresCufe(cufe:any = undefined) {
    //let codigoQr = "1cca40bc973ea81305e40b75427782bc6aa8d3a6c0e9ede7471e55665e48600cad58619ea89f214448317590ecbfc834"
    let codigoQr = ''
    if(cufe === undefined) {
      let responseCompania = await this.dian.devolverCompania()
      let companiaId = this.companiasId == undefined ? responseCompania : this.companiasId

      let cufeResponse = await this.dian.buscarCufe(companiaId,this.facturapos).toPromise()
      let cufeNuevo = JSON.parse(cufeResponse['_body'])
      if(cufe && cufeNuevo.data && cufeNuevo.data[0] && cufeNuevo.data[0][0]) {
        codigoQr = cufeNuevo.data[0] && cufeNuevo.data[0][0].cufe
        this.imprimirGlobal(this.facturapos,codigoQr)
      }
    } else {
      codigoQr = cufe
      this.imprimirGlobal(this.facturapos,codigoQr)
    }

  }

  async imprimirGlobal(text:any,cufe:string) {
    let ipAddress = await localStorage.getItem('ipAddress')
    let data = {
      factura:text
    }
          let popover = this.popoverCtrl.create(ImprimirGlobalComponent, { text: data,
            queHago:'imprimirFacturadia',
            cantidadImpresionesEnCaja: 1,
            ip:ipAddress,
            cufe:cufe
          });
          popover.present({
            ev: text
          });

          popover.onDidDismiss((data) => {
            if (data) {

              console.log(data);
            }
          });
        }


  imprimirFacturadia(codigo:any){
      this.storage.get('companiasId').then((val) => {
        let factura:number
        factura = Number(codigo)
        this.servicio.buscarVentasDiarias(factura,val)
        .subscribe((data)=>{
          let response = NUBE_AWS ? JSON.parse(data['_body']).data[0] : data
            this.reemprimirReciboDia(response)

         },
        error=>{
          console.log(error)
        })
      })
}

reemprimirReciboDia(mensaje) {
  let recibo = ''

for (let index:any = 0; index < mensaje.length; index++) {
  recibo +=  '   ' + mensaje[index]['reciboCaja'] + '\n'
}

  this.servicio.imprimirRecibo(recibo).subscribe(
      res => {

      },
      err => {
        this.utils.mostrarReciboDeCajaEnPantalla('',mensaje)

          })
}

}



// WEBPACK FOOTER //
// ./src/components/pos-electronico/pos-electronico.ts